import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';

@Component({
    selector: 'community-modal',
    templateUrl: './community-modal.component.html',
    styleUrls: ['./community-modal.component.scss']
})
export class CommunityModalComponent implements OnInit, OnDestroy {

    private _message: any;

    get message(): any {
        return this._message;
    }

    @Input()
    set message(message: any) {
        this._message = message;
        if (message != null) {
            this.refreshComments();
        }
    }

    @Output('photoClick')
    photoClickEventEmitter = new EventEmitter<string>();

    @Output('updateUser')
    updateUserEventEmitter = new EventEmitter<any>();

    comments: any[] = [];

    count: number = 0;

    browseBeforeInProgress!: boolean;

    constructor(
        private alertService: AlertService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    updateUser(user: any) {
        if (this.message.user.id == user.id) {
            this.message.user.banned = user.banned;
        }
        for (let comment of this.comments) {
            if (comment.user.id == user.id) {
                comment.user.banned = user.banned;
            }
        }
        this.updateUserEventEmitter.emit(user);
    }

    refreshComments() {
        this.comments = [];
        this.count = 0;
        this.browseBefore();
    }

    browseBefore() {
        let messageId = this.message.id;
        let commentId = null;
        if (this.comments.length > 0) {
            commentId = this.comments[this.comments.length - 1].id;
        }
        this.browseBeforeInProgress = true;
        this.communityService.browseComments(messageId, commentId).subscribe({
            next: (value: any) => {
                console.log('CommunityModalComponent.browseBefore.communityService.browseComments.value', value);
                this.browseBeforeInProgress = false;
                this.comments.push(...value.data);
                this.count = value.count - value.data.length;
                setTimeout(() => this.autoBrowseBefore(), 0);
            },
            error: (error: any) => {
                console.log('CommunityModalComponent.browseBefore.communityService.browseComments.error', error);
                this.browseBeforeInProgress = false;
                this.alertService.danger('Error');
            }
        });
    }

    autoBrowseBefore() {
        if (this.count > 0 && !this.browseBeforeInProgress) {
            this.browseBefore();
        }
    }

    emitPhotoClickEvent(path: string) {
        this.photoClickEventEmitter.emit(path);
    }
}
